import { ProfilesService } from "../../services/profiles/service";
import { kdProfileDataFromJson } from "../../domain/kdiagram/profiles/mapper";
import { kdProfileCreateDataToJson, kdProfileDataToJson } from "../../domain/kdiagram/profiles/mapper_to_json";
import { kdiagramEditProfileModule } from "./edit_profile";
import { kdiagramAddProfileModule } from "./add_profile";
import { kdiagramDeleteProfileModule } from "./delete_profile";

const profilesService = new ProfilesService(
  localStorage.getItem("basicUrl"),
  kdProfileDataFromJson,
  kdProfileCreateDataToJson,
  kdProfileDataToJson
);

const getDefaultState = () => {
  return {
    profiles: [],
    selectedProfile: null,
    fetchLoading: true,
    fetchError: null,
  };
};

const state = getDefaultState();

const getters = {
  fetchRequestFailed: (state) => (state.fetchError !== null),
};

const actions = {
  fetchProfiles: async ({ commit }, vesselName) => {
    commit("SET_FETCH_LOADING_STATE");
    try {
      const profiles = await profilesService.getMany(
        localStorage.getItem("quad_token"),
        vesselName
      );
      commit("SET_FETCH_SUCCESS_STATE", profiles);
    } catch (error) {
      commit("SET_FETCH_FAILED_STATE");
    }
  }
};

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState());
  },
  SET_SELECTED_PROFILE: (state, profile) => {
    state.selectedProfile = profile;
  },
  SET_FETCH_LOADING_STATE: (state) => {
    state.fetchLoading = true;
    state.fetchError = null;
  },
  SET_FETCH_FAILED_STATE: (state) => {
    state.fetchLoading = false;
    state.fetchError = "Failed to fetch profiles";
  },
  SET_FETCH_SUCCESS_STATE: (state, data) => {
    state.fetchLoading = false;
    state.fetchError = null;
    state.profiles = data;
  },
  SET_UPDATE_PROFILES_STATE: (state, profiles) => {
    state.profiles = profiles;
  },
  SET_UPDATE_PROFILE: (state, profile) => {
    state.selectedProfile = profile;
    const index = state.profiles.findIndex((p) => p.id === profile.id);
    if (index !== -1) {
      state.profiles[index] = profile;
    }
  }
};

export const kdiagramProfilesModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    addProfile: kdiagramAddProfileModule,
    editProfile: kdiagramEditProfileModule,
    deleteProfile: kdiagramDeleteProfileModule
  }
};
